import React from 'react';
import { Accordion,AccordionDetails,AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styled from "styled-components";
import useItems from '../../Hooks/useItems';
import Item from './Item';

const NoItemsText=styled.p`
text-align:center;
width:-webkit-fill-available;`;

const Items=({id})=>
{
    const Items=useItems(id);
    
    return <div>
        {Items.map(item => <Item item={item}/>)}
    </div>

}

const Categoria = ({categoria}) => 
{
    const {id,data}=categoria;
    const {Nombre}=data;


    return <div>
        <Accordion >
            <AccordionSummary  expandIcon={<ExpandMoreIcon />}>{Nombre}</AccordionSummary>
            <AccordionDetails style={{display:"block"}}>
            <Items id={id}/>
            </AccordionDetails>
        </Accordion>
    </div>
}

export default Categoria
